import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core'
import { FormControl, Validators } from '@angular/forms'
import { Store } from '@ngrx/store'
import { Subscription } from 'rxjs'
import { GlobalConstants } from 'src/app/constants/global-constants'
import { SelectedCompanyAPIModel } from 'src/app/models/api.model'
import { getSelectedCompaniesFromState } from 'src/app/store/selector/initialize.selector'
import { AppState } from 'src/app/store/state/app.state'

@Component({
  selector: 'app-company-selector',
  templateUrl: './company-selector.component.html',
  styleUrls: ['./company-selector.component.scss']
})
export class CompanySelectorComponent implements OnInit {
  @Output() selectedValueChange: EventEmitter<string> = new EventEmitter<string>()
  @Output() selectedCompany: EventEmitter<SelectedCompanyAPIModel> = new EventEmitter<SelectedCompanyAPIModel>()

  @Input() isRequired = true
  @Input() showCompanyGroup = false
  @Input() set companyId(companyId: string) {
    this._companyId = companyId
    this.setCompanyEntityId(companyId)
  }
  @Input() showError = false
  _companyId: string = null
  companies: SelectedCompanyAPIModel[] = []
  companyFormControl: FormControl = new FormControl('', [Validators.required])
  getSelectedCompaniesFromState$: Subscription

  constructor(private appState: Store<AppState>) {}

  private setCompanyEntityId(companyId: string) {
    if (!companyId) {
      this.companyFormControl.reset()
      this.emitValue(null)
      this.companyFormControl.enable()
    } else {
      const selectedCompany = this.findCompanyById(companyId)
      if (selectedCompany) {
        this.companyFormControl.setValue(selectedCompany.id)
        this.emitValue(selectedCompany)
        this.companyFormControl.disable()
      }
    }
  }

  ngOnInit(): void {
    this.getSelectedCompaniesFromState$ = this.appState
      .select(getSelectedCompaniesFromState)
      .subscribe(selectedCompanies => {
        if (selectedCompanies) {
          if (this.showCompanyGroup) {
            this.companies = selectedCompanies
          } else {
            this.companies = selectedCompanies.filter(sc => sc.type === GlobalConstants.COMPANY_TYPE.ENTITY)
          }
          const selectedCompanay = this.findCompanyById(this._companyId)
          if (selectedCompanay) {
            this.companyFormControl.setValue(selectedCompanay.id)
            this.emitValue(selectedCompanay)
            this.companyFormControl.disable()
          } else if (this.companies.length === 1) {
            this.companyFormControl.setValue(this.companies[0].id)
            this.emitValue(this.companies[0])
            this.companyFormControl.disable()
          }
        }
      })
  }

  onSelectChange(selectedValue: string) {
    this.emitValue(this.findCompanyById(selectedValue))
  }

  findCompanyById(id: string) {
    return this.companies?.filter(company => company?.id === id)?.[0] || null
  }

  emitValue(selectedCompany: SelectedCompanyAPIModel) {
    this.selectedValueChange.emit(selectedCompany?.id)
    this.selectedCompany.emit(selectedCompany)
  }

  ngOnDestroy() {
    this.getSelectedCompaniesFromState$?.unsubscribe()
  }
}
